<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [isBlur]="isBlur"
  [errors]="question.errors"
  [infos]="question.infos"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [dirty]="dirty"
  [display]="question.display"
  [formGroup]="formGroup"
  [type]="question.type"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>
<ng-container [formGroup]="formGroup">
  <ion-item>
    <ion-input
      [id]="'time-picker' + question.key"
      class="ion-text-start"
      [placeholder]="question.placeholder | translate"
      [formControlName]="question.key"
      [attr.disabled]="question.disabled"
      readonly="true"
    ></ion-input>
    <ion-modal
      [trigger]="'time-picker' + question.key"
      size="cover"
      alignment="center"
      [keepContentsMounted]="true"
    >
      <ng-template>
        <ion-content>
          <ion-datetime
            #timePicker
            presentation="time"
            mode="ios"
            [locale]="userLocale"
            [value]="pickerCurrentTime"
            [attr.disabled]="question.disabled"
            [attr.readonly]="question.readonly"
            [cancelText]="question.cancelText | translate"
            [doneText]="question.doneText | translate"
            [clearText]="'CLEAR' | translate"
            [hourCycle]="hourCycleFormat"
            showDefaultButtons="true"
            showClearButton="true"
            (ionFocus)="onFocus()"
            (ionBlur)="onBlur()"
            (ionChange)="onChange($event.detail.value)"
            (ionConfirm)="onConfirm($event.detail.value)"
            (ionCancel)="onCancel()"
            (ionClear)="onClear()"
          >
            <span slot="title"> {{ question.label }}</span>
          </ion-datetime>
        </ion-content>
      </ng-template>
    </ion-modal>
  </ion-item>
</ng-container>
